// src/locales/en.ts
export default {
    common: {
        home: "Home",
        manage: "Manage",
        documents: "Documents",
        documentLibrary: "Document Library",
        uploadDocument: "Upload Document",
        myDocuments: "My Documents",
        myWall: "My Wall",
        login: "Login",
        register: "Register",
        logout: "Logout",
        settings: "Settings & Privacy",
        support: "Support",
        userGuide: "User Guide",
        theme: "Theme",
        viewProfile: "View Profile",
        light: "Light",
        dark: "Dark",
        auto: "Auto",
        seeAll: "See all",
        loading: "Loading...",
        save: "Save",
        cancel: "Cancel",
        continue: "Continue",
        back: "Back",
        next: "Next",
        close: "Close",
        clear: "Clear all",
        search: "Search...",
        notifications: "Notifications",
        new: "new",
        accept: "Accept",
        delete: "Delete",
        yes: "Yes",
        no: "No",
        error: "Error",
        success: "Success",
        warning: "Warning",
        info: "Info",
        minutes: "minutes",
        hours: "hours",
        days: "days",
        ago: "ago",
        confirmAction: "Are you sure you want to perform this action?",
        language: "Language",
        helpTranslate: "Help translate",
        view: "View",
        edit: "Edit",
        submit: "Submit",
        confirm: "Confirm",
        previous: "Previous",
        all: "All",
        none: "None",
        other: "Other",
        more: "Show More",
        less: "Show Less",
        comingSoon: "Coming Soon",
        filter: "Filter",
        sort: "Sort",
        quick: "Quick",
        actions: "Actions",
        sortBy: "Sort by",
        download: "Download",
        pagination: "Showing {{from}} to {{to}} of {{total}} items",
        noSubscription: "No Subscription",
        total: "Total",
        clearFilters: "Clear Filters",
        choose: "Choose",
        file: "File",
        or: "or",
        dragDrop: "drag and drop",
        up: "up",
        to: "to",
        select: "Select",
        enter: "Enter",
        keyword: "Keyword",
        email: "Email",
        publicDescription: "Public Description",
        upload: "Upload",
        viewDetails: "View Details",
        showing: "Showing",
        of: "of",
        results: "results",
        filters: "Filters",
        status: "Status",
        export: "Export",
        items: "items",
        sortOptions: {
            newest: "Newest First",
            oldest: "Oldest First",
            activity: "Recent Activity",
            downloads: "Most Downloads",
            spent: "Most Spent",
            amountHigh: "Amount (High to Low)",
            amountLow: "Amount (Low to High)",
            priceHigh: "Price (High to Low)",
            priceLow: "Price (Low to High)",
            revenue: "Highest Revenue",
            relevance: "Relevance",
            priority: "Priority",
            reports: "Reports Count"
        },
        locales: {
            vi: "Vietnamese",
            en: "English"
        }
    },
    auth: {
        login: "Login",
        register: "Register",
        logout: "Logout",
        forgotPassword: "Forgot Password",
        resetPassword: "Reset Password",
        username: "Username",
        email: "Email",
        password: "Password",
        confirmPassword: "Confirm Password",
        firstName: "First Name",
        lastName: "Last Name",
        rememberMe: "Remember me",
        loginSubtitle: "Sign in to your account",
        registerSubtitle: "Create a new account to manage copyright",
        registerSuccess: "Registration successful",
        registerSuccessMessage: "Thank you for registering with Vietrro. We have sent a confirmation email to",
        passwordRequirements: "Password must be at least 8 characters",
        alreadyHaveAccount: "Already have an account?",
        dontHaveAccount: "Don't have an account?",
        agreeTerms: "I agree to the",
        termsOfService: "Terms of Service",
        and: "and",
        privacyPolicy: "Privacy Policy",
        loginNow: "Login now",
        registerNow: "Register now",
        registerAccount: "Register Account",
        emailVerification: "Please check your inbox and click on the confirmation link to complete the registration process.",
        approvalRequired: "Your account belongs to a user group that requires approval. Please wait for an administrator to approve your account. We will notify you by email when your account is approved.",
        openEmail: "Open email",
        loginButton: "Login",
        registerButton: "Register Account",
        phoneNumber: "Phone Number",
        organization: "Organization/Company Name",
        taxId: "Tax ID",
        businessInfo: "Business Information",
        userInfo: "User Information",
        forgotPasswordButton: "Reset Password",
        guest: "Guest"
    },
    register: {
        step1: "Choose Role",
        step2: "Personal Information",
        step3: "Confirmation",
        selectRole: "Select your role in the system",
        selectMultipleRoles: "Select multiple roles",
        selectedRoles: "Selected roles:",
        noRoleSelected: "No role selected",
        noRoleAvailable: "No user groups available for registration.",
        validateUsername: "Username must be at least 4 characters",
        usernameAvailable: "Username is available",
        usernameNotAvailable: "Username already exists or is invalid",
        confirmInformation: "Confirm information",
        role: "Role",
        fullName: "Full name",
        phoneNumber: "Phone number",
        organization: "Organization",
        taxId: "Tax ID",
        specificRoles: "Specific roles",
        approvalNote: "Note: Your account will need approval before you can use all features.",
        registrationComplete: "Registration complete"
    },
    header: {
        home: "Home",
        myWall: "My Wall",
        manage: "Management",
        identityProtection: "Identity Protection",
        marketplace: "Marketplace",
        documentMenu: "Documents",
        documentLibrary: "Document Library",
        uploadDocument: "Upload Document",
        myDocuments: "My Documents",
        settings: "Settings",
        viewProfile: "View Profile",
        logout: "Logout",
        userGuide: "User Guide",
        theme: "Theme",
        openMenu: "Open menu",
        closeMenu: "Close menu",
        education: 'Education',
        educationDashboard: 'Education Dashboard',
        educationDocuments: 'Education Documents',
        educationSettings: 'Education Settings',
        messaging: "Messages",
        notifications: {
            title: "Notifications",
            empty: "No new notifications",
            seeAll: "See all incoming activity"
        }
    },
    search: {
        placeholder: "Search...",
        ariaLabel: "Search",
        submit: "Search",
        advancedSearch: "Advanced Search",
        filters: "Filters",
        results: "Search Results"
    },
    user: {
        profile: "Profile",
        settings: "Settings",
        accountSettings: "Account Settings",
        privacySettings: "Privacy Settings",
        notificationSettings: "Notification Settings",
        securitySettings: "Security Settings",
        verifiedBadge: "Verified Badge",
        membership: "Membership",
        memberSince: "Member since",
        mutualConnections: "Mutual Connections"
    },
    content: {
        registerWork: "Register New Work",
        manageCatalog: "Manage Catalog",
        updateMetadata: "Update Metadata",
        revenueDashboard: "Revenue Dashboard",
        withdrawPayment: "Withdraw Payment",
        reportViolation: "Report Violation",
        identityProtection: "Identity Protection Center"
    },
    license: {
        exploreWorks: "Explore Copyright Works",
        purchaseLicense: "Purchase License",
        licensePayments: "License Payments",
        viewContracts: "View Current Contracts",
        manageContracts: "Extend/Cancel Contracts",
        viewExpiredContracts: "View Expired Contracts"
    },
    navigation: {
        home: "Home",
        dashboard: "Dashboard",
        profile: "Profile",
        userProfile: "User Profile",
        settings: "Settings",
        vietrroHome: "Vietrro Home",
        general: "General",
        copyrightManagement: "Copyright Management",
        licensing: "Licensing",
        education: "Education",
        documents: "Documents",
        monitoring: "Monitoring",
        legal: "Legal",
        administration: "Administration",
        account: "Account",
        protection: "Copyright Protection",
        userWall: "User Wall",
        logout: "Logout"
    },
    education: {
        "sidebar": {
            "menu": "Menu",
            "expand": "Expand",
            "collapse": "Collapse",
            "close": "Close menu",
            "logout": "Logout",
            "user": {
                "guest": "Guest",
                "noRole": "User",
                "teacher": "Teacher",
                "student": "Student",
                "admin": "Administrator",
                "user": "User",
                "online": "Online"
            },
            "dashboard": {
                "title": "Dashboard",
                "overview": "Overview",
                "teacher": "Teacher Dashboard",
                "student": "Student Dashboard"
            },
            "documents": {
                "title": "Documents",
                "all": "All Documents",
                "upload": "Upload Document",
                "myDocuments": "My Documents",
                "myPurchases": "Purchased",
                "myDownloads": "Downloaded"
            },
            "subscription": {
                "title": "Subscription",
                "plans": "Subscription Plans",
                "mySubscription": "My Subscription"
            },
            "revenue": {
                "title": "Revenue",
                "earnings": "Earnings",
                "analytics": "Revenue Analytics",
                "withdraw": "Withdraw"
            },
            "payments": {
                "title": "Payments",
                "history": "Payment History",
                "methods": "Payment Methods"
            },
            "analytics": {
                "title": "Analytics",
                "overview": "Analytics Overview",
                "documents": "Document Analytics",
                "revenue": "Revenue Analytics",
                "users": "User Analytics"
            },
            "profile": {
                "title": "Profile",
                "teacher": "Teacher Profile",
                "student": "Student Profile",
                "verification": "Account Verification"
            },
            "admin": {
                "title": "Administration",
                "teachers": "Manage Teachers",
                "students": "Manage Students",
                "verification": "Account Verification",
                "moderation": "Content Moderation"
            },
            "settings": {
                "title": "Settings",
                "general": "General Settings",
                "notifications": "Notifications",
                "privacy": "Privacy"
            },
            "help": {
                "title": "Help",
                "faq": "Frequently Asked Questions",
                "contact": "Contact Support"
            },
            "notifications": {
                "title": "Notifications"
            }
        },
        dashboard: {
            title: "Education Dashboard",
            welcome: "Welcome to Vietrro Education",
            welcomeTeacher: "Welcome back, {{name}}! Your educational resources are making a difference.",
            welcomeStudent: "Welcome back, {{name}}! Ready to learn something new today?",
            teacher: "Teacher Dashboard",
            student: "Student Dashboard",
            stats: "Statistics",
            recentDocuments: "Recent Documents",
            recentActivities: "Recent Activities",
            welcomeMessage: "Welcome {{name}}",
            totalDocuments: "Total Documents",
            myDocuments: "My Documents",
            recentUploads: "Recent Uploads",
            earnings: "Earnings",
            downloads: "Downloads",
            reviews: "Reviews",
            averageRating: "Average Rating",
            activeSubscription: "Active Subscription",
            overview: "Dashboard Overview",
            statistics: {
                thisMonth: "This Month",
                lastMonth: "Last Month"
            }
        },
        documents: {
            title: "Educational Documents",
            searchPlaceholder: "Search documents...",
            uploadDocument: "Upload Document",
            documentDetails: "Document Details",
            myDocuments: "My Documents",
            editDocument: "Edit Document",
            reviews: "Reviews",
            filterBySubject: "Filter by Subject",
            filterByLevel: "Filter by Education Level",
            documentTypes: {
                learning_material: "Learning Material",
                reference_material: "Reference Material",
                research_paper: "Research Paper",
                study_guide: "Study Guide"
            },
            educationLevels: {
                primary: "Primary",
                secondary: "Secondary",
                high_school: "High School",
                university: "University",
                masters: "Master's",
                phd: "Ph.D"
            },
            status: {
                approved: "Approved",
                pending: "Pending",
                rejected: "Rejected",
                draft: "Draft",
                deleted: "Deleted"
            },
            noDocuments: "No documents found",
            recentDownloads: "Recent Downloads",
            savedDocuments: "Saved Documents",
            browseLibrary: "Browse Library",
            documentCount: "Document Count",
            noResults: "No Results Found",
            tryAnotherSearch: "Try another search term",
            subjects: {
                math: "Mathematics",
                literature: "Literature",
                english: "English",
                physics: "Physics",
                chemistry: "Chemistry",
                biology: "Biology",
                history: "History",
                geography: "Geography",
                informatics: "Informatics",
                economics: "Economics",
                art: "Art",
                music: "Music",
                physical_education: "Physical Education"
            }
        },
        subscription: {
            title: "Subscription Plans",
            plans: "Plan List",
            mySubscription: "My Subscription",
            upgrade: "Upgrade Plan",
            downgrade: "Downgrade Plan",
            cancel: "Cancel Plan",
            renew: "Renew Plan",
            status: {
                active: "Active",
                pending: "Pending",
                expired: "Expired",
                cancelled: "Cancelled",
                suspended: "Suspended",
                none: "None",
                inactive: "Inactive"
            },
            actions: {
                manageBilling: "Manage Billing",
                subscribe: "Subscribe"
            },
            newSubscriber: "New Subscribers",
            my: "My Subscription",
            noActiveSubscription: "No Active Subscription",
            subscribeToPlan: "Subscribe to a Plan",
            activeSubscription: "Active Subscription",
            inactiveMessage: "You don't have an active subscription",
            purchaseCount: "Purchase Count",
            subtitle: "Access premium educational content",
            whySubscribe: "Why Subscribe?",
            benefitTitles: {
                unlimitedDownloads: "Unlimited Downloads",
                premiumContent: "Premium Content",
                collaboration: "Teacher Collaboration",
                analytics: "Usage Analytics"
            },
            benefitDescs: {
                unlimitedDownloads: "Download as many documents as you need",
                premiumContent: "Access exclusive high-quality materials",
                collaboration: "Connect with professional educators",
                analytics: "Track your learning progress"
            },
            choosePlan: "Choose a Plan",
            allPlans: "All Plans",
            studentPlans: "Student Plans",
            teacherPlans: "Teacher Plans",
            autoRenew: "Auto-renew subscription",
            active: "Active",
            expired: "Expired",
            none: "None"
        },
        payments: {
            title: "Payments",
            history: "Payment History",
            methods: {
                title: "Payment Methods",
                add: "Add Method",
                edit: "Edit Method",
                delete: "Delete Method"
            },
            revenue: {
                title: "Revenue Management",
                withdraw: "Withdraw Funds",
                history: "Withdrawal History"
            }
        },
        analytics: {
            title: "Analytics",
            overview: "View detailed statistics and reports",
            documents: "Document Analytics",
            revenue: "Revenue Analytics",
            users: "User Analytics",
            noData: "No Analytics Data Available"
        },
        users: {
            teachers: {
                title: "Teachers",
                profile: "Teacher Profile",
                verification: "Teacher Verification"
            },
            students: {
                title: "Students",
                profile: "Student Profile"
            }
        },
        admin: {
            title: "Education Administration",
            accountApproval: "Account Approval",
            moderation: "Document Moderation",
            students: "Students",
            verification: "Verification",
            // moderation: "Moderation"
        },
        student: {
            purchases: "Purchased Documents",
            downloads: "Downloaded Documents",
            myDownloads: "My Downloads",
            myDownloadsDescription: "Manage all documents you have downloaded from the system",
            downloadedOn: "Downloaded on: {{date}}",
            remainingDownloads: "{{count}} downloads remaining",
            noDownloads: "No downloads yet",
            noDownloadsDescription: "You haven't downloaded any documents yet. Browse and download documents from our library.",
            browseDocuments: "Browse documents"
        },
        settings: {
            title: "Settings",
            general: {
                title: "General Settings"
            },
            notifications: {
                title: "Notification Settings"
            },
            privacy: {
                title: "Privacy Settings"
            },
            tabs: {
                profile: "Profile",
                notifications: "Notifications",
                privacy: "Privacy",
                preferences: "Preferences",
                security: "Security",
                payments: "Payments",
                data: "Data"
            },
            loading: "Loading Settings...",
            description: "Manage your account settings and preferences",
            profile: {
                info: "Profile Information",
                displayName: "Display Name",
                bio: "Biography",
                bioPlaceholder: "Tell us about yourself...",
                website: "Website",
                socialLinks: "Social Links"
            }
        },
        help: {
            title: "Help",
            faq: "FAQ",
            categories: {
                gettingStarted: "Getting Started",
                subscription: "Subscription",
                documents: "Documents",
                payments: "Payments",
                upload: "Upload",
                verification: "Verification",
                general: "General"
            },
            categoryDescriptions: {
                upload: "Learn how to upload documents",
                subscription: "Information about subscription plans",
                payment: "Help with payment methods and billing",
                verification: "Understand the verification process",
                general: "General questions about the platform"
            },
            contact: {
                title: "Contact Support",
                form: "Contact Form",
                email: "Support Email",
                phone: "Support Phone"
            },
            loading: "Loading Help Center...",
            description: "Find answers to your questions",
            searchPlaceholder: "Search for help topics...",
            quickHelp: "Quick Help",
            questions: "Questions",
            frequentlyAskedQuestions: "Frequently Asked Questions",
            noQuestions: "No questions found",
            selectCategory: "Select a category",
            askQuestion: "Ask a Question",
            contactSupport: "Contact Support",
            liveChat: "Live Chat",
            liveChatDescription: "Chat with our support team",
            startChat: "Start Chat",
            emailDescription: "Email our support team",
            replyWithin24h: "We'll reply within 24 hours",
            hotlineDescription: "Call our support hotline",
            resources: "Resources",
            videoTutorials: "Video Tutorials",
            videoTutorialsDescription: "Learn with step-by-step videos",
            userManual: "User Manual",
            userManualDescription: "Complete platform documentation",
            freeCourses: "Free Courses",
            freeCoursesDescription: "Learn how to use the platform effectively"
        },
        notifications: {
            title: "Notifications",
            markAsRead: "Mark as Read",
            markAllAsRead: "Mark All as Read",
            clear: "Clear All",
            empty: "No Notifications",
            unread: "Unread",
            settings: {
                title: "Notification Settings"
            },
            priority: {
                high: "High Priority"
            },
            types: {
                document: "Document",
                payment: "Payment"
            },
            search: "Search notifications...",
            viewDetails: "View Details",
            channels: {
                app: "In-App",
                email: "Email"
            }
        },
        navigation: {
            dashboard: "Dashboard",
            overview: "Overview",
            teacherDashboard: "Teacher Dashboard",
            studentDashboard: "Student Dashboard",
            documents: "Documents",
            allDocuments: "All Documents",
            uploadDocument: "Upload Document",
            myDocuments: "My Documents",
            myPurchases: "My Purchases",
            myDownloads: "My Downloads",
            subscription: "Subscription",
            subscriptionPlans: "Subscription Plans",
            mySubscription: "My Subscription",
            revenue: "Revenue",
            earnings: "Earnings",
            analytics: "Analytics",
            withdraw: "Withdraw",
            payments: "Payments",
            paymentHistory: "Payment History",
            paymentMethods: "Payment Methods",
            management: "Management",
            students: "Students",
            verification: "Verification",
            moderation: "Moderation",
            settings: "Settings",
            general: "General",
            notifications: "Notifications",
            privacy: "Privacy",
            help: "Help",
            faq: "FAQ",
            contact: "Contact",
            closeMobileMenu: "Close menu",
            documentAnalytics: "Document Analytics",
            revenueAnalytics: "Revenue Analytics",
            userAnalytics: "User Analytics",
            profile: "Profile",
            teacherProfile: "Teacher Profile",
            studentProfile: "Student Profile",
            admin: "Administration",
            teachers: "Manage Teachers",
            mainMenu: "Main Menu"
        },
        forms: {
            uploadForm: {
                title: "Document Information",
                documentTitle: "Document Title",
                description: "Description",
                selectFile: "Select File",
                documentType: "Document Type",
                subject: "Subject",
                educationLevel: "Education Level",
                price: "Price",
                coAuthors: "Co-Authors",
                freeDocument: "Free Document",
                keywords: "Keywords",
                sharePercentage: "Share Percentage",
                addCoAuthor: "Add Co-Author",
                publicDocument: "Public Document",
                preview: "Preview"
            }
        },
        validation: {
            required: "This field is required",
            minLength: "Minimum {{count}} characters",
            maxLength: "Maximum {{count}} characters",
            invalidEmail: "Invalid email",
            minPrice: "Price must be greater than {{min}}"
        },
        teacherManagement: "Teacher Management",
        manageTeachers: "Manage teacher accounts, verifications, and permissions",
        teacher: "Teacher",
        teacherInfo: "Teacher Information",
        allStatus: "All Statuses",
        allVerification: "All Verification Statuses",
        allInstitutions: "All Institutions",
        status: {
            active: "Active",
            suspended: "Suspended",
            pending: "Pending",
            inactive: "Inactive"
        },
        verification: {
            title: "Teacher Verification",
            description: "Complete your profile information to verify your teacher status",
            notFound: "Verification Not Found",
            notFoundDesc: "The verification you are looking for doesn't exist or has been removed",
            reviewMode: "Review teacher verification details",
            status: {
                draft: "Draft",
                submitted: "Submitted",
                pending: "Pending Review",
                underReview: "Under Review",
                approved: "Approved",
                rejected: "Rejected",
                expired: "Expired"
            },
            personalInfo: "Personal Information",
            professionalInfo: "Professional Information",
            documents: "Verification Documents",
            documentTypes: {
                id_card: "ID Card / Passport",
                passport: "Passport",
                degree: "Degree / Diploma",
                teaching_license: "Teaching License",
                employment_letter: "Employment Confirmation",
                other: "Other Document"
            },
            documentStatus: {
                pending: "Pending",
                verified: "Verified",
                rejected: "Rejected"
            },
            addDocument: "Add Document",
            documentType: "Document Type",
            selectFiles: "Select Files",
            noDocuments: "No documents uploaded yet",
            uploadFirst: "Upload your first document",
            requiredDocuments: "Required Documents",
            submit: "Submit for Verification",
            approve: "Approve",
            reject: "Reject",
            confirmSubmit: "Submit Verification",
            confirmSubmitMessage: "Are you sure you want to submit your verification? You won't be able to edit it after submission until the review is complete.",
            confirmApproval: "Approve Verification",
            confirmApprovalMessage: "Are you sure you want to approve this teacher verification?",
            reviewNotePlaceholder: "Add any notes about this approval (optional)",
            confirmRejection: "Reject Verification",
            confirmRejectionMessage: "Please provide a reason for rejection. This will be shown to the teacher.",
            rejectionReasonPlaceholder: "Reason for rejection (required)",
            rejected: "Verification Rejected",
            expired: "Verification Expired",
            uploadFiles: "Upload Files",
            uploadDocument: "Upload Document",
            dateOfBirth: "Date of Birth",
            nationality: "Nationality",
            institutionName: "Institution Name",
            institutionType: "Institution Type",
            institutionAddress: "Institution Address",
            department: "Department",
            position: "Position",
            teacherIdNumber: "Teacher ID Number",
            yearsOfExperience: "Years of Experience",
            specializations: "Specializations",
            addSpecialization: "Add specialization (press Enter)",
            employmentStartDate: "Employment Start Date",
            reviewHistory: "Review History",
            actions: {
                submitted: "Submitted",
                approved: "Approved",
                rejected: "Rejected",
                requested_changes: "Requested Changes"
            },
            verified: "Verified",
            pending: "Pending",
            // rejected: "Rejected"
        },
        suspend: "Suspend",
        activate: "Activate",
        activeTeachers: "Active Teachers",
        pendingVerification: "Pending Verification",
        suspendedTeachers: "Suspended Teachers",
        newThisMonth: "New This Month",
        institution: "Institution",
        department: "Department",
        statistics: "Statistics",
        lastLogin: "Last Login",
        teacherIdNumber: "Teacher ID",
        confirmSuspend: "Suspend Teacher",
        suspendWarning: "This will prevent the teacher from uploading new documents and earning revenue. Are you sure?",
        suspendReason: "Suspension reason (required)",
        confirmDelete: "Delete Teacher",
        deleteTeacherWarning: "This action cannot be undone. All teacher data including documents and earnings will be permanently deleted.",
        noTeachers: "No teachers found matching your criteria",
        searchTeachers: "Search teachers by name, email, institution...",
        addTeacher: "Add Teacher",
        editTeacher: "Edit Teacher",
        permissions: {
            DOCUMENT_UPLOAD: "Upload Documents",
            STUDENT_MANAGEMENT: "Manage Students",
            ANALYTICS: "View Analytics",
            EXPORT_DATA: "Export Data"
        },
        institutionTypes: {
            university: "University",
            college: "College",
            high_school: "High School",
            private_institution: "Private Institution",
            other: "Other"
        },
        joinedAt: "Joined At",
        recentActivity: "Recent Activity",
        institutionName: "Institution Name",
        earnings: {
            title: "Earnings & Revenue",
            trackRevenue: "Track your earnings and withdraw funds",
            totalEarnings: "Total Earnings",
            pendingPayments: "Pending Payments",
            availableWithdraw: "Available for Withdrawal",
            platformFee: "Platform Fee",
            withdraw: "Withdraw",
            fromLastMonth: "from last month",
            willBeAvailable: "Will be available in 30 days",
            yourShare: "Your Share",
            revenueChart: "Revenue Chart",
            revenueSources: "Revenue Sources",
            revenueSharing: "Revenue Sharing",
            afterPlatformFee: "after platform fee",
            coAuthorsShare: "Co-Authors Share",
            distributedAmongCoAuthors: "Distributed among content co-authors",
            platformFeeAmount: "Platform Fee Amount",
            serviceFee: "service fee",
            topEarningDocuments: "Top Earning Documents",
            sales: "Sales",
            earnings: "Earnings",
            trend: "Trend",
            withdrawalHistory: "Withdrawal History",
            date: "Date",
            amount: "Amount",
            bankInfo: "Bank Info",
            status: "Status",
            transactionId: "Transaction ID",
            requestWithdrawal: "Request Withdrawal",
            withdrawAmount: "Withdrawal Amount",
            available: "Available",
            selectBank: "Select Bank",
            accountNumber: "Account Number",
            accountHolder: "Account Holder Name",
            enterAccountNumber: "Enter your account number",
            enterAccountHolder: "Enter account holder name",
            withdrawalNote: "Important Notes",
            withdrawalTime: "Withdrawal requests are processed within 3-5 business days",
            minimumWithdrawal: "Minimum withdrawal amount is 50,000 VND",
            transactionFee: "A 1% transaction fee will be applied to the withdrawal amount",
            confirmWithdraw: "Confirm Withdrawal",
            withdrawalStatus: {
                pending: "Pending",
                processing: "Processing",
                completed: "Completed",
                failed: "Failed"
            },
            sources: {
                sales: "Direct Sales",
                subscription: "Subscription Revenue",
                referral: "Referral Bonus",
                bonus: "Bonus Rewards"
            },
            exportReport: "Export Report",
            noData: "No earnings data available"
        },
        educationLevels: {
            primary: "Primary School",
            secondary: "Secondary School",
            high_school: "High School",
            university: "University",
            masters: "Master's Degree",
            phd: "PhD"
        },
        totalDocuments: "Total Documents",
        totalRevenue: "Total Revenue",
        totalDownloads: "Total Downloads",
        totalStudents: "Total Students",
        document: {
            title: "Title",
            downloads: "Downloads",
            rating: "Rating"
        },
        dateRange: {
            last7Days: "Last 7 Days",
            last30Days: "Last 30 Days",
            last3Months: "Last 3 Months",
            lastYear: "Last Year",
            all: "All Time"
        },
        sorts: {
            recent: "Most recent",
            title: "By title",
            type: "By document type"
        },
        filters: {
            educationLevel: "Education level",
            documentType: "Document type",
            subject: "Subject",
            all: "All"
        },
        errors: {
            fetchFailed: "Could not load data. Please try again later.",
            downloadFailed: "Could not download document. Please try again later.",
            downloadHistoryError: "An error occurred while loading download history",
            networkAfterRetry: "Could not connect to server after multiple attempts.",
            unauthorized: "You do not have permission to perform this action.",
            notFound: "The requested data was not found.",
            badRequest: "Invalid request.",
            fileTooLarge: "The uploaded file is too large.",
            serverError: "Server error.",
            network: "Network connection error.",
            generic: "An error occurred.",
            approvalError: "Error loading approval data",
            approveFailed: "Failed to approve request",
            rejectFailed: "Failed to reject request"
        },
        documentManagement: "Document Management",
        newDocument: "New Document",
        selectAll: "Select All",
        noDocuments: "No Documents Found",
        createFirstDocument: "Create Your First Document",
        confirmDeleteMessage: "Are you sure you want to delete this document?",
        thisMonth: "This Month",
        searchDocuments: "Search Documents",
        recommendations: {
            title: "Recommended for You",
            noRecommendations: "No recommendations available"
        },
        purchase: {
            myPurchases: "My Purchases",
            manageDownloads: "Manage Downloads",
            totalPurchases: "Total Purchases",
            totalSpent: "Total Spent",
            completedPurchases: "Completed Purchases",
            totalDownloads: "Total Downloads",
            searchPurchases: "Search purchases...",
            allStatus: "All Statuses",
            status: {
                completed: "Completed",
                pending: "Pending",
                failed: "Failed",
                refunded: "Refunded"
            },
            noPurchases: "No purchases found",
            startBrowsing: "Start Browsing"
        },
        payment: {
            history: "Payment History",
            trackAllTransactions: "Track All Transactions",
            listView: "List View",
            chartView: "Chart View",
            totalPayments: "Total Payments",
            totalAmount: "Total Amount",
            pendingPayments: "Pending Payments",
            failedPayments: "Failed Payments",
            searchPayments: "Search payments...",
            allTypes: "All Types",
            types: {
                purchase: "Purchase",
                subscription: "Subscription",
                withdrawal: "Withdrawal"
            },
            allStatus: "All Statuses",
            status: {
                completed: "Completed",
                pending: "Pending",
                failed: "Failed",
                refunded: "Refunded"
            },
            allMethods: "All Methods",
            methods: {
                credit_card: "Credit Card",
                bank_transfer: "Bank Transfer",
                e_wallet: "E-Wallet",
                paypal: "PayPal"
            },
            transaction: "Transaction",
            type: "Type",
            amount: "Amount",
            paymentMethod: "Payment Method"
        },
        studentManagement: "Student Management",
        manageStudents: "Manage Students",
        addStudent: "Add Student",
        searchStudents: "Search students...",
        allSubscriptions: "All Subscriptions",
        allYears: "All Years",
        year: "Year",
        activeStudents: "Active Students",
        activeSubscriptions: "Active Subscriptions",
        suspendedStudents: "Suspended Students",
        studentId: "Student ID",
        activity: "Activity",
        approval: {
            accountApprovals: "Account Approvals",
            reviewAndManageApplications: "Review and manage account registration requests",
            searchApplications: "Search applications...",
            allApplications: "All Applications",
            applicationDetails: "Application Details",
            applicantInfo: "Applicant Information",
            verificationInfo: "Verification Information",
            submittedDocuments: "Submitted Documents",
            reviewNotes: "Review Notes",
            enterReviewNotes: "Enter review notes (optional)",
            previousReview: "Previous Review",
            reviewedBy: "Reviewed by",
            reviewedAt: "Reviewed at",
            notes: "Notes",
            submittedAt: "Submitted at",
            review: "Review",
            approve: "Approve",
            reject: "Reject",
            confirmApproval: "Confirm Approval",
            confirmApprovalMessage: "Are you sure you want to approve this request?",
            confirmRejection: "Confirm Rejection",
            confirmRejectionMessage: "Please provide a reason for rejection:",
            enterRejectionReason: "Enter rejection reason (required)",
            rejectionReasonRequired: "Please enter rejection reason",
            viewDocument: "View Document",
            pendingApplications: "Pending Applications",
            underReview: "Under Review",
            approvedToday: "Approved Today",
            rejectedToday: "Rejected Today",
            noApplications: "No Applications",
            noApplicationsDescription: "There are currently no approval requests to process",
            status: {
                pending: "Pending",
                reviewing: "Reviewing",
                approved: "Approved",
                rejected: "Rejected"
            }
        },
        moderation: {
            title: "Content Moderation",
            subtitle: "Review and manage educational content",
            searchPlaceholder: "Search content...",
            allStatus: "All Statuses",
            status: {
                pending: "Pending",
                reviewing: "Reviewing",
                approved: "Approved",
                rejected: "Rejected",
                flagged: "Flagged"
            },
            pending: "Pending Review",
            reviewing: "Under Review",
            flagged: "Flagged Content",
            approvedToday: "Approved Today",
            submittedAt: "Submitted at"
        },
        priority: {
            title: "Priority",
            all: "All Priorities",
            high: "High",
            medium: "Medium",
            low: "Low"
        },
        userTypes: {
            teacher: "Teacher",
            student: "Student"
        },
        allUserTypes: "All User Types",
        userType: "User Type",
        documentType: "Document Type",
        documentTypes: {
            all: "All Document Types",
            learning_material: "Learning Material",
            reference_material: "Reference Material",
            research_paper: "Research Paper",
            study_guide: "Study Guide"
        },
        institutionType: "Institution Type",
        major: "Major",
        classYear: "Class Year",
        uploadedAt: "Uploaded at"
    },
    errors: {
        unauthorized: "Unauthorized Access",
        notFound: "Page Not Found",
        serverError: "Server Error",
        networkError: "Network Error",
        unknownError: "Unknown Error"
    },
    public: {
        about: "About",
        features: "Features",
        contact: "Contact",
        tagline: "Vietnam's leading platform for copyright management and digital licensing",
        company: "Company",
        team: "Team",
        careers: "Careers",
        resources: "Resources",
        blog: "Blog",
        help: "Help",
        faq: "FAQ",
        legal: "Legal",
        privacyPolicy: "Privacy Policy",
        termsOfService: "Terms of Service",
        cookiePolicy: "Cookie Policy",
        connect: "Connect",
        allRightsReserved: "All rights reserved"
    }
};